import request from '@/utils/request'

export function operation(data) {
  return request({
    url: '/app/user/operation',
    method: 'post',
    data
  })
}

export function getData(data) {
  return request({
    url: '/app/user/selectOne',
    method: 'post',
    data
  })
}
